module.exports = __webpack_public_path__ + "static/partnership_process_obj05@2x-060d9dc1f60c7324dddc00d854b94bd1.png";